import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Self, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-gateway-selector',
    templateUrl: './gateway-selector.component.html',
    styleUrls: ['./gateway-selector.component.scss'],
    standalone: false
})
export class GatewaySelectorComponent implements OnInit, ControlValueAccessor, OnChanges {

  public gatewayChipId: string | null = null;
  @Output()
  public gatewayIdChange = new EventEmitter<string | null>();

  public InitChipId = "";
  @Input()
  public Gateway: any = {};

  public searchResults: any[] = [];
  public searchTerm: string = "ChipId";
  public isLoading = false;

  constructor(private apiService: ApiServiceBase, @Self() public ngControl: NgControl) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.gatewayChipId = this.Gateway.ChipId;
    this.onChange(this.Gateway.ChipId);
    this.gatewayIdChange.emit(this.Gateway);
  }

  public writeValue(id: string | null): void {
    console.log("Write value");

    this.gatewayChipId = id;
    this.Gateway.ChipId = id;
    if (this.gatewayChipId == "") this.Gateway = null;
  }
  public onChange = (id: string | null) => {
    this.gatewayIdChange.emit(id);
   };
   
  public registerOnChange(fn: any): void {
    console.log("Reg on change");

    this.onChange = fn;
  }
  public onTouched = () => { };
  public registerOnTouched(fn: any): void {
    console.log("On Touched");

    this.onTouched = fn;
  }
  ngOnInit(): void {
  }


  public ItemSelected(item: any) {
    if (item && item != null && item.Id) {
      this.Gateway = { Id: item.Id, ChipId: item.ChipId, OrganizationId: item.OrganizationId };
      this.gatewayChipId = item.ChipId;
      this.onChange(item.ChipId);
      this.gatewayIdChange.emit(this.Gateway);
    }
  }
  public SearchChanged(val: string) {
    console.log("Sensor Selector search event: '" + val + "'");
    if (val == null || val == "") return;
    this.Gateway = null;
    this.isLoading = true;
    //"infrastructure/sensor/searches"
    this.apiService.Post<any>("hardware/gateways/searches", { PageNumber: 1, PageSize: 8, SearchTerm: val }).then(result => {
      this.searchResults = [];
      result.Results.forEach((element: any) => {
        this.searchResults.push({
          ChipId: element.ChipId.toString(),
          Id: element.Id,
          OrganizationId: element.OrganizationId
        });
      });

      console.log("Search results: ");

      console.log(this.searchResults);

      this.isLoading = false;
    });
  }
  public ClearGateway() {
    this.gatewayChipId = null;
    this.onChange(null);
  }

  public Cleared() {
    this.gatewayChipId = null;
    this.onChange(null);
  }
  public KeyPress(evt: any) {
    if (evt.keyCode == 13) {
      evt.stopPropagation();
    }
  }
  public InputKeyPress(evt: any) {

  }

}
